import { gql } from '@apollo/client';
import type { FleetCompanyContract, FleetCompanyContracts, FleetCompanyOnboardingStatus } from '../../__generated__/graphql';
import graphQLRequester from '../../request/GraphQLRequester';

export class GraphQLFleetContractsRequester {
  public getFleetContracts = async (fleetId: string): Promise<FleetCompanyContract[]> => {
    if (!fleetId) return [];

    return graphQLRequester
      .query<{ contracts: FleetCompanyContracts }>({
        query: gql`
          query contracts($fleetId: String!) {
            contracts(fleetId: $fleetId) {
              fleetId
              contracts {
                companyId
                companyStatus
                corporateName
                cnpj
                contractSignedDate
                address
                phone
                industry
                responsavel
                lastRegistrationChangeDate
                mrrCurrency
                billingDay
                dueDay
                paymentMethod
                paymentFrequency
                financialAdjustmentIndex
                recentConversionEventName
                upsellBlockLoggedArea
              }
            }
          }
        `,
        variables: { fleetId },
      })
      .then((result) => (result.contracts.contracts?.filter(Boolean) ?? []) as FleetCompanyContract[]);
  };

  public getFleetCompanyOnboardingStatus = (fleetId: string): Promise<FleetCompanyOnboardingStatus> =>
    graphQLRequester
      .query<{ companyOnboardingStatus: FleetCompanyOnboardingStatus }>({
        query: gql`
          query companyOnboardingStatus($fleetId: String!) {
            companyOnboardingStatus(fleetId: $fleetId) {
              hasAnyOnboardingContract
              hasAnyContractSignedInLast90Days
            }
          }
        `,
        variables: { fleetId },
      })
      .then((result) => result.companyOnboardingStatus);
}

export default GraphQLFleetContractsRequester;
